import styled from '@emotion/styled';
import MuiMenuList from '@material-ui/core/MenuList';
import COLORS from '$variables/colors';
import { typography } from '$variables/theme';

export const styles = {
  paper: {
    'box-shadow': `0px 0px 8px 0px ${COLORS.shadow3}`,
    'margin-top': '4px',
  },
};

export const LeftDecorationContainer = styled.div`
  margin-right: 8px;
  height: 24px;
  width: 24px;
`;

export const MenuItem = styled.div`
  padding: 6px 12px;
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};
  line-height: 20px;
  background-color: ${COLORS.white};
  white-space: normal;
  color: ${({ disabled }) => (disabled ? COLORS.grey4 : COLORS.black)};

  :hover {
    ${({ disabled }) => (disabled ? '' : `background-color: ${COLORS.grey4};`)}
  }

  ${({ disabled }) => (disabled ? 'cursor: not-allowed;' : 'cursor: pointer;')}
  border-bottom: 1px solid ${COLORS.grey4};
`;

export const MenuList = styled(MuiMenuList)`
  outline: none;
`;

export const SubText = styled.div`
  text-transform: uppercase;
  font-size: 10px;
  color: ${({ disabled }) => (disabled ? COLORS.grey4 : COLORS.shadow5)};
  font-weight: ${typography.fontWeightRegular};
`;
